import React from 'react';
import { InfoTransparentIcon } from 'ui/Icons/components/InfoTransparent.component';
import { HidingTooltip } from 'ui/Tooltip';
import { theme } from '../../../../../tailwind.config';
import { useResponsive } from 'containers/CRM/hooks/useResponsive';

interface IMetricCardProps {
  children: React.ReactNode;
}

export const MetricCard: React.FC<IMetricCardProps> = ({ children }) => (
  <div className="border border-solid border-gray-20 flex flex-1 flex-col h-[230px] items-center justify-between p-[20px]">
    {children}
  </div>
);

interface IMetricCardTitleProps {
  title: string;
  renderTooltipContent: () => React.ReactNode;
}

export const MetricCardTitle: React.FC<IMetricCardTitleProps> = ({ title, renderTooltipContent }) => {
  const { isMobile, isTablet } = useResponsive();
  const tooltipWidth = isMobile || isTablet ? '110px' : '170px';
  return (
    <div className="flex gap-[5px] items-center justify-center">
      <p className="m-0 font-pt-sans text-[13px] leading-[22px] tracking-[0.52px] uppercase text-black mb-[5px] crm-tablet:mb-0">
        {title}
      </p>
      <HidingTooltip position="bottom-right" width={tooltipWidth} renderTooltipContent={renderTooltipContent}>
        <InfoTransparentIcon width={16} height={16} fill={theme.colors['gray-60']} />
      </HidingTooltip>
    </div>
  );
}
